/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner } from './disable-physical-store-payment-for-the-user-account200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { DisablePhysicalStorePaymentForTheUserAccount200ResponseReissue } from './disable-physical-store-payment-for-the-user-account200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { DisablePhysicalStorePaymentForTheUserAccount200ResponseUser } from './disable-physical-store-payment-for-the-user-account200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { DisablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup } from './disable-physical-store-payment-for-the-user-account200-response-user-account-group';

/**
 * 
 * @export
 * @interface DisablePhysicalStorePaymentForTheUserAccount200Response
 */
export interface DisablePhysicalStorePaymentForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'availableCurrencies': Array<DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner>}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'availableMerchantCategories': Array<DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {DisablePhysicalStorePaymentForTheUserAccount200ResponseUser}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'user': DisablePhysicalStorePaymentForTheUserAccount200ResponseUser;
    /**
     * 
     * @type {DisablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'userAccountGroup'?: DisablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {DisablePhysicalStorePaymentForTheUserAccount200ResponseReissue}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'reissue'?: DisablePhysicalStorePaymentForTheUserAccount200ResponseReissue | null;
}

export const DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum = typeof DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum[keyof typeof DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum];


